import React from "react";

const TermofUse = () => {
  return (
    <>
      <div className="min-h-screen mt-[86px] bg-white py-10 px-4 flex justify-center">
        <div className="w-full max-w-4xl">
          <h1 className="text-center text-[#0f172a ] font-semibold text-xl mb-2">
            Magma OPD
          </h1>
          <h2 className="text-center text-[#8b5cf6] font-extrabold text-5xl mb-6">
            TERMS &amp; CONDITIONS
          </h2>
          <div className="border border-[#8b5cf6] p-8 rounded-md space-y-4 text-slate-700">
            <p>
              These terms and conditions (“Terms of Use” / “Terms”) constitute a
              binding and enforceable contract between InfoMagma Solutions (OPC)
              Private Limited, a private limited company having its registered office at 
              {/* <strong>Basement, 5B-16, Tilak Nagar New Delhi 110018</strong> */}
              (hereinafter referred to as “we”, “us”, “our”, “Company” or “Magma
              OPD”), and you, an end user (hereinafter referred to as “you”, “your”,
              “User”, “Customer”) in relation to the use of the website{" "}
              <strong>www.Magma OPD.in</strong> (referred to as the “Online
              Platform”). You represent and warrant that you have full legal capacity
              and authority to agree and bind yourself to these Terms. Magma OPD and
              the User are collectively referred to as “Parties” and singularly
              referred to as “Party”.
            </p>
            <p className="mt-4">
              Please read the Terms carefully prior to using, signing up or
              registering on our Online Platform or accessing/availing our Services.
              By signing up to use the Online Platform, you acknowledge that you have
              read these Terms and agree to be bound by them. You also acknowledge
              that you have read our Privacy Policy and agree to be bound by it. By
              signing up to use the Online Platform, you represent that you have
              provided us with valid identifying information which may be used to
              verify your identity. Please note that we may restrict, suspend, or
              terminate your access at any time to the Online Platform if we believe
              you have breached these Terms. We may use certain technologies to
              monitor your activities on the Online Platform in accordance with our
              Privacy Policy.
            </p>
            <p className="mt-4">
              We may modify these Terms or any other terms at any time by posting a
              revised version of the same on the Online Platform, and the amended
              version of these Terms shall become automatically binding upon you if
              you continue to avail the Services. The amended Terms will be applicable
              even if not accepted by you separately. You shall have the
              responsibility to review these Terms on a regular basis. If you do not
              wish to be bound by the updated Terms, we request you to stop accessing
              the Online Platform and the Services.
            </p>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">DEFINITIONS</h3>
            <p>
              For the purpose of these Terms, the following words and phrases shall
              have the meaning assigned to them hereunder.
            </p>
            <p className="mt-2">
              <strong>“Applicable Law”</strong> includes all applicable Indian
              statutes, enactments, acts of the state legislature or parliament, laws,
              ordinances, rules, bye-laws, regulations, notifications, guidelines,
              directions, directives and orders of any governmental authority,
              statutory authority, board, recognized stock exchange, as may be
              applicable.
            </p>
            <p className="mt-2">
              <strong>“Confidential Information”</strong> means and includes the
              Intellectual Property and any and all business, technical and financial
              information of Magma OPD or of any of its affiliates that is related to
              any of the arrangements contemplated in these Terms or any other
              document in which these Terms are incorporated by reference, or
              otherwise disclosed by Magma OPD to the User. This includes any
              information which relates to its financial and/or business operations,
              including but not limited to: specifications, models, merchant
              lists/information samples, reports, forecasts, current or historical
              data, computer programs or documentation and all other technical,
              financial or business data, internal management, customers, products,
              services, anticipated products/services, processes, financial condition,
              employees, merchants, Intellectual Property, marketing strategies,
              experimental work, trade secrets, business plans, business proposals,
              customer contract terms and conditions, and other valuable confidential
              information and materials that are customarily treated as confidential
              or proprietary, whether or not specifically identified as such.
            </p>
            <p className="mt-4">
              <strong>“Intellectual Property”</strong> shall mean all intellectual
              property used for the purpose of or in association with or in relation
              to the performance of these Terms, and includes without limitation: (a)
              software, operating manuals, software code, programs, instructions,
              specifications, processes, input methods, data or information used in
              relation to or in association with the operation of software installed
              by Magma OPD; (b) trademarks, service marks, trade names, business
              names, logos, symbols, styles, colour combinations used by Magma OPD
              during the course of its business and all associated depictions,
              derivations, graphics, images, content and the ‘look and feel’ thereof;
              (c) all information, data or material in any form provided by Magma OPD
              to the User during the usage of the Online Platform; and (d) all
              techniques, formulae, patterns, compilations, processes, inventions,
              practices, methodologies, improvements, procedures, designs, skills,
              notes, experimental results, specifications, rights on software, and any
              other know-how of any nature whatsoever.
            </p>
            <p className="mt-4">
              <strong>“Services”</strong> shall mean the services provided by Magma
              OPD to the Users utilizing the Online Platform, including all content,
              features, technologies or functions offered or made available on the
              Online Platform including but not limited to: <br />
              a. Wellness Plans; <br />
              b. Healthcare Plans;
            </p>
            <p className="mt-4">
              <strong>“Service Provider”</strong> shall mean any entity with which
              Magma OPD has, directly or indirectly, executed an agreement for
              facilitating any Services to the Users in association with such entity.
            </p>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">ELIGIBILITY</h3>
            <p className="mt-2">
              By accepting these Terms, you hereby declare and confirm that:
              <br />
              i. you are a resident of India,
              <br />
              ii. you are above 18 (Eighteen) years of age,
              <br />
              iii. you have the capacity to enter into a legally binding contract as
              specified under the Indian Contract Act, 1872, while availing the
              Services offered by Magma OPD,
              <br />
              iv. you are not barred or otherwise legally prohibited from accessing or
              using the Services under any Applicable Law.
            </p>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              Use of the Website and Service
            </h3>
            <p className="mt-2">
              These Terms and Conditions (“Terms”) govern your access to and use of
              the Magma OPD Website, Magma OPD App, and Magma OPD Call Centers
              (collectively referred to as the “Platform”) and the SaaS-based
              healthtech infrastructure we provide (the “Service”). By accessing or
              using the Platform or Service, you agree to be bound by these Terms.
            </p>
            <p className="mt-2">
              You agree to use the Website and Service solely for lawful purposes and
              in accordance with these Terms. You are prohibited from using the
              Website or Service in any way that:
              <br />• Could damage, disable, overburden, or impair the Website or
              Service.
              <br />• Interferes with any other user’s enjoyment of the Website or
              Service.
              <br />• Attempts to gain unauthorized access to the Website or Service,
              or any connected computer systems or networks.
              <br />• Uploads, transmits, or stores content that is unlawful,
              harassing, defamatory, obscene, or otherwise objectionable.
              <br />• Violates any applicable laws or regulations.
            </p>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              PLATFORM ACCESS
            </h3>
            <p className="mt-2">
              By using or accessing the Online Platform, you represent and warrant
              that:
            </p>
            <ol className="list-[lower-roman] list-inside text-slate-700 mt-2 space-y-1">
              <li>
                you are accessing the Online Platform on your own initiative and are
                responsible for compliance with all local laws and regulations
                applicable to you;
              </li>
              <li>you are of the legal age to access the Online Platform;</li>
              <li>
                you are solely responsible for the user content and all activities
                that occur on or through your device;
              </li>
              <li>
                you agree not to undertake activities which include but are not
                limited to infringing any proprietary rights, including but not
                limited to Intellectual Property, or Confidential Information, of
                Magma OPD or Service Provider; except as may be provided hereunder,
                copying, displaying, distributing, modifying, publishing, reproducing,
                storing, transmitting, posting, translating, creating any derivative
                works, renting, or licensing the Online Platform or any portion
                thereof;
              </li>
              <li>caching unauthorized hypertext links to the Online Platform;</li>
              <li>
                uploading, posting, or transmitting any material that contains
                software viruses, trojan horses, worms, time-bombs, keystroke loggers,
                spyware, adware or any other computer code, files or programs designed
                to interrupt, destroy or limit the functionality of any computer
                software or hardware or telecommunications equipment;
              </li>
              <li>
                undertaking any action that imposes or may impose, in our sole
                discretion, an unreasonable or disproportionately large load on our
                infrastructure;
              </li>
              <li>
                use of data mining, robots, spiders, scrapers, crawlers, avatars or
                similar data gathering and extraction tools;
              </li>
              <li>
                making any back-up or archival copies of the Online Platform or any
                part thereof;
              </li>
              <li>
                bypassing any measures used by us to prevent or restrict access to the
                Online Platform;
              </li>
              <li>using the Online Platform for any commercial purpose;</li>
              <li>
                violating the restrictions in any robot exclusion headers on the
                Online Platform or bypassing or circumventing other measures employed
                to prevent or limit access to the Online Platform;
              </li>
              <li>
                deep-linking to any portion of the Online Platform (including, without
                limitation, the purchase path for any service) for any purpose without
                our express written permission;
              </li>
              <li>
                ‘framing’, ‘mirroring’ or otherwise incorporating any part of the
                Online Platform into any other website without our prior written
                authorization;
              </li>
              <li>
                use the Online Platform in (i) any unlawful manner, (ii) for
                fraudulent or malicious activities, or (iii) in any manner
                inconsistent with these Terms or violate Applicable Laws in any
                manner.
              </li>
            </ol>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              General Terms:
            </h3>
            <ul className="list-disc list-inside text-slate-700 mt-2 space-y-1">
              <li>
                The Service is available to anyone who registers with{" "}
                <strong>Magma OPD</strong>.
              </li>
              <li>
                <strong>Magma OPD</strong> Standard Members can only access
                information about health centers.
              </li>
              <li>
                Only one <strong>Magma OPD</strong> plan can be used at a time.
              </li>
              <li>
                <strong>Magma OPD</strong> Health Plans benefits cannot be combined
                with EMI no-interest features.
              </li>
            </ul>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              User Content
            </h3>
            <p className="mt-2">
              You are solely responsible for any content you upload, transmit, or
              store on the Website or Service. By submitting content, you grant{" "}
              <strong>Magma OPD</strong> a non-exclusive, royalty-free license to use,
              reproduce, modify, publish, and distribute your User Content in
              connection with the Website and Service.
            </p>
            <p className="mt-2">
              You agree and understand that all of the content accessed by you on the
              Online Platform is purely for informational purposes aimed to provide
              details and additional data about or in connection with the Online
              Platform and the Services.
            </p>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              Test Booking &amp; Services:
            </h3>
            <ul className="list-disc list-inside text-slate-700 mt-2 space-y-1">
              <li>
                Tests must be booked through Magma OPD at least 5 working days in
                advance at a center of your choice.
              </li>
              <li>
                If your chosen center is not on the Magma OPD network, we’ll assist in
                adding it or help you find an alternate networked center.
              </li>
              <li>
                By selecting a center, you indemnify Magma OPD from any mishaps
                before, during, or after the tests.
              </li>
              <li>
                “Test/s” includes consultations, appointments, tests, procedures,
                surgeries, medications, or anything else related, even if not
                specifically mentioned in the Terms of Use.
              </li>
            </ul>
            <h3 className="text-lg font-semiboldtext-[#64748B] mt-6">
              Description of Services:
            </h3>
            <ul className="list-disc list-inside text-slate-700 mt-2 space-y-1">
              <li>
                Magma OPD only facilitates access to healthcare services including
                diagnostics and medical by booking appointments and offering
                discounted rates. We do not provide healthcare services directly.
              </li>
              <li>
                Magma OPD is not responsible for any outcomes resulting from the use
                of these services.
              </li>
              <li>We do not guarantee service timing with healthcare providers.</li>
              <li>
                Magma OPD does not verify or cross-check the regulatory authorization,
                licenses, or certifications of healthcare providers and is not liable
                for any regulatory breaches or malpractice.
              </li>
              <li>
                By using the site and sharing your details, you agree to avail of the
                services you selected.
              </li>
              <li>
                You consent to Magma OPD or its partners contacting you for
                fulfillment or promotional purposes via electronic or non-electronic
                means.
              </li>
            </ul>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              ACCURACY OF INFORMATION
            </h3>
            <p className="mt-2">
              Although we may post information, material and content on the Online
              Platform based on reliable sources, we do not make any express or
              implied representation, warranty or guarantee as to the accuracy,
              validity, reliability or completeness of any such information. The
              features and services of the Online Platform are provided on an “as is”
              and “as available” basis. We make no representation or warranty about
              the validity, accuracy, correctness, reliability of any information
              provided on or through the Online Platform.
            </p>
            <h3 className="text-lg font-semibold text-[#64748B] mt-6">
              Intellectual Property
            </h3>
            <p>
              All rights, title, and interest in and to the Online Platform, including
              all Intellectual Property rights arising out of the Online Platform, are
              owned by or otherwise licensed to Magma OPD. Subject to your compliance
              with these Terms, Magma OPD grants you a non-exclusive,
              non-transferable, non-sub licensable, royalty-free, revocable, and
              limited licence to use the Online Platform in accordance with the Terms
            </p>
            <p>
              Except as expressly authorized by Magma OPD, the User agrees not to
              sell, license, distribute, copy, modify, publicly perform or display,
              transmit, publish, edit, adapt, create derivative works from, or
              otherwise make unauthorized use of the Magma OPD’s Intellectual
              Property. User do not accrue any rights or interest in Magma OPD’s
              Intellectual Property and use of any Intellectual Property by User shall
              be strictly in for the fulfillment of and in compliance with the Terms.
              User undertake that it shall not, nor will it allow others to, reverse
              engineer or disassemble any parts of Magma OPD’s Intellectual Property.
            </p>
            <p>
              Magma OPD may request you to submit suggestions and other feedback,
              including bug reports, relating to the Online Platform from time to time
              (“Feedback”). Magma OPD may freely use, copy, disclose, create
              derivative works on, publish, display, distribute, and exploit the
              Feedback without any payment of royalty, acknowledgement, prior consent,
              or any other form of restriction arising out of your Intellectual
              Property rights. Magma OPD shall be at liberty to make changes/updates
              to the Online Platform as may be required and Magma OPD shall have all
              such rights as mentioned under this section on the
              additions/modifications.
            </p>
            <p>You represent and warrant that:</p>
            <ol className="list-[lower-roman] list-inside text-slate-700 mt-2 space-y-1">
              <li>
                you shall use the Intellectual Property solely for discharge of your
                duties for the usage of the Online Platform;
              </li>
              <li>
                you shall use Intellectual Property of Magma OPD only in the form and
                manner stipulated by Magma OPD;
              </li>
              <li>
                you shall seek prior written consent from Magma OPD for use of Magma
                OPD’s Intellectual Property which is not previously provided for by
                Magma OPD;
              </li>
              <li>
                . you shall bring to Magma OPD’s notice all cases concerning Magma
                OPD’s Intellectual Property’s (a) infringement, (b) passing off, (c)
                registration, or (d) attempted registration;
              </li>
              <li>
                {" "}
                you shall render to Magma OPD all assistance in connection with any
                matter pertaining to the protection of Magma OPD’s Intellectual
                Property whether in courts, before administrative agencies, or
                otherwise
              </li>
              <li>
                you shall refrain from taking any action which shall or may impair
                Magma OPD’s right, title or interest in the Intellectual Property, or
                create any right, title or interest therein or thereto, adverse to
                that of Magma OPD;
              </li>
              <li>
                you shall not use or permit to be used the Intellectual Property by
                any unauthorized person, and
              </li>
              <li>
                you shall not misuse the Intellectual Property or use it together with
                any other mark or marks.
              </li>
            </ol>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              CONFIDENTIALITY
            </h3>
            <p>
              The User shall keep Confidential Information as confidential. The User
              confirms that it shall protect Confidential Information with such
              security, confidentiality and degree of utmost care as it would
              prudently apply to its own confidential information and use it solely in
              connection with the transaction to which the Confidential Information
              relates. The User acknowledges and agrees that it is aware of the
              sensitivity and secrecy involved in keeping such data/information and
              transaction records and shall ensure that neither the User nor its
              affiliates will do any act to violate the same. Confidential Information
              shall exclude any information:
            </p>
            <ol className="list-[lower-roman] list-inside text-slate-700 mt-2 space-y-1">
              <li>
                which is already in the possession of the receiving Party and not
                subject to any other duty of confidentiality;
              </li>
              <li>
                that is at the date hereof, or subsequently becomes, public otherwise
                than by reason of a breach by the receiving Party of these Terms;
              </li>
              <li>
                Information that becomes legally available to the receiving Party
                and/or its affiliates or professional advisors on a non-confidential
                basis from any third party, the disclosure of which does not, to the
                knowledge of that Party, violate any contractual or legal obligation
                which such third party has to the other Party with respect to such
                information;
              </li>
              <li>
                Information that is independently acquired or developed by the
                receiving Party.
              </li>
            </ol>
            <p className="mt-4">
              Provided however, that Magma OPD may make the following disclosures for
              which no consent shall be required from the User:
            </p>
            <ol className="list-[lower-roman] list-inside text-slate-700 mt-2 space-y-1">
              <li>
                Disclosures to its directors, officers, employees,
                affiliates/subsidiaries/group/holding companies, Service Providers and
                any employees thereof that it reasonably determines need to receive
                the Confidential Information;
              </li>
              <li>
                Disclosures to its legal and other professional advisers, instructed
                by it that it reasonably determines need to receive the Confidential
                Information;
              </li>
              <li>
                Disclosures to any person to whom it is required by any Applicable Law
                or any applicable regulatory, supervisory, judicial or governmental
                order, to disclose such information, or at the request of any
                regulatory or supervisory or judicial or government authority.
              </li>
            </ol>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              COMMUNICATION POLICY
            </h3>
            <p>
              As part of the User’s usage of the Services, the User may receive
              notifications, offers, discounts and general information from Magma OPD
              via text messages or by emails, for the purpose of collecting Feedback
              regarding its Services. The User understands that receipt of non-service
              related communications can be deactivated by User by sending mail to
              hello@Magma OPD.in and by ab-initio consents to receive such these
              communications. The User acknowledges that the SMS service provided by
              Magma OPD is an additional facility provided for the User’s convenience
              and that it may be susceptible to error, omission and/ or inaccuracy.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">Disclaimers</h3>
            <p>
              THE WEBSITE AND SERVICE ARE PROVIDED “AS IS” AND WITHOUT WARRANTIES OF
              ANY KIND, EITHER EXPRESS OR IMPLIED. Magma OPD DISCLAIMS ALL WARRANTIES,
              INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
            <p>
              Magma OPD DOES NOT WARRANT THAT THE WEBSITE OR SERVICE WILL BE
              UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE
              WEBSITE OR SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Limitation of Liability
            </h3>
            <p>
              <strong>Magma OPD</strong> SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF
              OR IN CONNECTION WITH YOUR USE OF THE WEBSITE OR SERVICE.
            </p>
            <p>
              In no event shall Magma OPD or any of its subsidiaries or affiliates be
              liable to you or any person for any direct, indirect, special,
              consequential or other damages (including, without limitation, any lost
              profits, business interruption, loss of information or programs or other
              data on your information handling system) that are related to the use
              of, or the inability to use, the Services and functions of the Online
              Platform, even if expressly advised of the possibility of such damages.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Terms and Termination
            </h3>
            <ul className="list-disc list-inside text-slate-700 mt-2 space-y-1">
              <li>
                These Terms shall remain in full force and effect until terminated by
                you or <strong>Magma OPD.</strong>
              </li>
            </ul>
            <p>
              <strong>Magma OPD</strong> may suspend or terminate your plans if any
              information provided is found to be inaccurate, incomplete, or outdated.
            </p>
            <p>
              <strong>Magma OPD</strong> reserves the right, in its sole and absolute
              discretion, to suspend or terminate your use of one or more Services,
              without notice and without liability to you or any third party, for any
              reason, including without limitation inactivity or violation of these
              Terms or other applicable policies we may publish from time to time. Any
              termination of the Services may also be effectuated through the Service
              Provider and
            </p>
            <p>
              <strong>Magma OPD</strong> shall not be held liable for the same. You
              agree and understand to abide all the terms &amp; conditions stipulated
              under these Terms and of the Service Provider upon termination of the
              Services.
            </p>
            <p>
              Any suspected fraudulent, abusive or illegal activity may be referred to
              appropriate law enforcement authorities. These remedies are in addition
              to any other remedies
            </p>
            <p>
              <strong>Magma OPD</strong> may have at law or in equity. Upon
              termination for any reason, you agree to immediately stop using the
              Services of <strong>Magma OPD</strong>.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Dispute Resolution &amp; Governing Law
            </h3>
            <p>
              At Magma OPD, we value transparency and customer satisfaction. In the
              unlikely event of a dispute arising from any transaction, product, or
              service:
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Step 1: Internal Resolution
            </h3>
            <p>
              Customers are encouraged to first reach out to our Grievance Redressal
              Team by writing to us at preventivepulsehealth@gmail.com with the
              subject line: “Dispute Resolution – [Order ID]”.
            </p>
            <p>
              We aim to resolve all complaints within 10 business days of receipt.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Step 2: Escalation
            </h3>
            <p>
              If the issue remains unresolved after Step 1, the customer may escalate
              the matter by sending a formal written complaint to the Magma OPD
              Compliance Officer at preventivepulsehealth@gmail.com We shall attempt a
              good-faith resolution through mediation within 15 business days.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Step 3: Legal Recourse
            </h3>
            <p>
              If a resolution is still not reached, the matter shall be subject to
              legal proceedings:
            </p>
            <ul className="list-disc list-inside text-slate-700 mt-2 space-y-1">
              <li>
                Governing Law: This policy and all transactions undertaken through
                Magma OPD shall be governed by and construed in accordance with the
                laws of India.
              </li>
              <li>
                Jurisdiction: Subject to the foregoing, all disputes, claims, or
                proceedings shall be subject to the exclusive jurisdiction of the
                competent courts at New Delhi, India.
              </li>
            </ul>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              THIRD PARTY SERVICES AND LINKS
            </h3>
            <p>
              Our Services contain or may contain, links to third-party websites,
              applications, content, products, services and resources that are not
              under the control and do not form a part of the Services offered by the
              Magma OPD. We provide these links only for your convenience and Magma
              OPD makes no representation or warranty of any kind regarding its
              accuracy, reliability, effectiveness, or correctness and shall not be
              responsible or liable for any aspect of any such third-party services.
            </p>
            <p>
              The User acknowledges sole responsibility for reading and understanding
              the Terms and Privacy Policy and assumes all risk that applies to their
              use of any third-party services. Further, the User acknowledges that the
              information may be transferred, stored or utilised by a third party, and
              you consent to such transfer and <strong>Magma OPD</strong> shall not be
              responsible for the security of such information.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Entire Agreement
            </h3>
            <p>
              These Terms constitute the entire agreement between you and Magma OPD
              with respect to the use of the Website and Service.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              FORCE MAJEURE
            </h3>
            <p>
              If performance of the Services by Magma OPD is prevented, restricted,
              delayed or interfered with by reason of and including, but not limited
              to, labour disputes, strikes, acts of God, floods, lightning, severe
              weather, shortages of materials, rationing, inducement of any virus,
              malware, trojan or other disruptive mechanisms, pandemic, epidemic, any
              event of hacking or illegal usage of the Online Platform, utility or
              communication failures, earthquakes, pandemic, lockdown, war,
              revolution, acts of terrorism, civil commotion, acts of public enemies,
              blockade, embargo or any law, order, proclamation, regulation,
              ordinance, demand or requirement having legal effect of any government
              or any judicial authority or representative of any such government, or
              any other act whatsoever, whether similar or dissimilar to those
              referred to in this clause, which are beyond the reasonable control of
              Magma OPD and could not have been prevented by reasonable precautions,
              then Magma OPD shall be excused and discharged from such performance to
              the extent of and during the period of such force majeure event, and
              such non-performance shall, in no manner whosoever, amount to a breach
              by Magma OPD of its obligations herein or incur any legal liability on
              Magma OPD.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">INDEMNITY</h3>
            <p>
              You agree to indemnify and hold Magma OPD and its affiliates harmless
              against all actions, claims, demands, proceedings, losses, damages,
              costs, charges and expenses whatsoever which Magma OPD may at any time
              incur, sustain, suffer or be put to as a consequence of or by reason of
              or arising due to any negligence/mistake/misconduct on your part or
              breach or non-compliance of any provision of these Terms by you or any
              person using your behalf.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Severability
            </h3>
            <p>
              If any provision of these Terms is held to be invalid or unenforceable,
              such provision shall be struck and the remaining provisions shall remain
              in full force and effect. In the event any provision of these Terms is
              determined to be invalid or unenforceable, such provision shall be
              deemed severed from the remainder of these Terms and replaced with a
              valid and enforceable provision as similar in intent as reasonably
              possible to the provision so severed, and shall not cause the invalidity
              or unenforceability of the remainder of these Terms.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              ASSIGNMENT AND WAIVER
            </h3>
            <p>
              These Terms and any rights and licenses granted hereunder, may not be
              transferred or assigned by you. We may assign, in whole or in part, the
              benefits or obligations hereunder. We may, at our discretion, provide an
              intimation of such assignment to you, which will be binding on the
              Parties to these Terms. Unless otherwise expressly stated, the failure
              to exercise or delay in exercising a right or remedy under these Terms
              will not constitute a waiver of the right or remedy or a waiver of any
              other rights or remedies, and no single or partial exercise of any right
              or remedy under these Terms will prevent any further exercise of the
              right or remedy or the exercise of any other right or remedy.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Update to Terms
            </h3>
            <p>
              <strong>Magma OPD </strong>may update these Terms at any time by posting
              the amended terms on the Website. Your continued use of the Website or
              Service following the posting of amended Terms constitutes your
              acceptance of the amended Terms.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">Contact Us</h3>
            If you have any questions about these Terms, please reach out to our
            support team:
            <ul className="list-disc list-inside space-y-2 text-slate-700">
              <li>
                <strong>Email :</strong>preventivepulsehealth@gmail.com
              </li>
              <li>
                <strong>Phone:</strong> 9899761818
              </li>
              <li>
                <strong>Support Hours:</strong> Mon – Sat, 10:00 am to 6:00 pm
              </li>
              <li>
                <strong>Website</strong>www.magmaopd.in
              </li>
              <p>We’re here to help you every step of the way.</p>
            </ul>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              Legal Disclaimer
            </h3>
            By engaging in any transaction with <strong> Magma OPD</strong>, all
            customers acknowledge and agree to the following terms. Any violation of
            the terms mentioned below may result in legal consequences as per the
            applicable laws.
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              17.1 No Unauthorized Inducements or Commitments
            </h3>
            <p>
              No individual shall, directly or indirectly, offer or induce another
              person to engage in a transaction under false pretenses.
              <strong>Magma OPD</strong> does not assume responsibility for any false
              commitments or inducements made by its agents or telemarketing
              representatives regarding the sale of any product. If there is any doubt
              regarding the authenticity of a commitment or representation, it may be
              verified through a confirmation call conducted by Magma OPD after any
              payment is made. Customers may also verify any transaction within{" "}
              <strong> fifteen (15) days </strong> of payment by contacting customer
              service at 011-43658206 or via email at{" "}
              <strong>preventivepulsehealth@gmail.com</strong> No agreement may be
              challenged after fifteen (15) days from the date of issuance or
              commencement of risk coverage.
            </p>
            <h3 className="text-lg text-[#64748B] font-semibold mt-6">
              17.2 Third-Party Payments
            </h3>
            <p>
              <strong>Magma OPD</strong> will not be held liable for any payments made
              by customers to third parties or any payments made by a third party on
              behalf of the customer. If a customer makes a payment to any third party
              under any undue influence or coercion, the responsibility lies solely
              with the customer. <strong>Magma OPD</strong> disclaims all liability in
              such circumstances. The Company does not accept cash payments for any
              transactions. Customers are strongly advised to refrain from making cash
              transactions under any circumstances, as<strong> Magma OPD</strong> will
              not be accountable for such payments.
            </p>
            <p>This website is operated by INFOMAGMA SOLUTIONS OPC PVT LTD</p>
          </div>
        </div>
      </div>

    </>
  );
};

export default TermofUse;
